import type { A3CPhotoSettings, DetectionConstraints, EnabledWarnings } from '@imaaagery/a3camera';

export const DETECTION_CONSTRAINTS_CENTER: DetectionConstraints = {
	backDistance: 0.8,
	frontDistance: 0.4,
	positionRight: 0.25,
	positionLeft: 0.25,
	positionTop: 0.55,
	positionBottom: 0.7,
	rotation: 4,
	brightnessDiff: 30,
	brightnessLevel: 50,
};

export const DETECTION_CONSTRAINTS_RIGHT: DetectionConstraints = {
	...DETECTION_CONSTRAINTS_CENTER,
	positionRight: 0.9,
	positionLeft: 0.7,
	brightnessLevel: 0,
	brightnessDiff: 75,
	rotation: 10,
	positionTop: 0.8,
	positionBottom: 0.8,
};

export const DETECTION_CONSTRAINTS_LEFT: DetectionConstraints = {
	...DETECTION_CONSTRAINTS_CENTER,
	positionRight: 0.7,
	positionLeft: 0.9,
	rotation: 10,
	brightnessLevel: 0,
	brightnessDiff: 75,
	positionTop: 0.8,
	positionBottom: 0.8,
};

export const VIDEO_CONSTRAINTS: MediaTrackConstraints = {
	width: { ideal: 3072 },
	height: { ideal: 2304 },
	aspectRatio: 0.75,
	facingMode: 'user',
};

export const PHOTO_SETTINGS: A3CPhotoSettings = {
	width: 1152,
	height: 1536,
};

export const WARNINGS: EnabledWarnings = {};

export const CAPTURE_DEPTH_THRESHOLDS = {
	center: { min: -0.05, max: 0.05 },
	right: { min: 0.06, max: 0.2 },
	left: { min: -0.2, max: -0.06 },
};
